var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de3149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2273d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#053b94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002e7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81c1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ab1e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27a07e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f9171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e8ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107fdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffef36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f5715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a480d"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9047619 6.47619048s1.90476191-1.52380953 1.90476191-3.04761905c0-1.52380953-1.90476191-3.04761905-1.90476191-3.04761905s-1.9047619 1.52380952-1.9047619 3.04761905c0 1.52380952 1.9047619 3.04761905 1.9047619 3.04761905z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9047619 6.47619048s1.90476191-1.52380953 1.90476191-3.04761905c0-1.52380953-1.90476191-3.04761905-1.90476191-3.04761905s-1.9047619 1.52380952-1.9047619 3.04761905c0 1.52380952 1.9047619 3.04761905 1.9047619 3.04761905z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9047619 6.47619048s1.90476191-1.52380953 1.90476191-3.04761905c0-1.52380953-1.90476191-3.04761905-1.90476191-3.04761905s-1.9047619 1.52380952-1.9047619 3.04761905c0 1.52380952 1.9047619 3.04761905 1.9047619 3.04761905z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9047619 6.47619048s1.90476191-1.52380953 1.90476191-3.04761905c0-1.52380953-1.90476191-3.04761905-1.90476191-3.04761905s-1.9047619 1.52380952-1.9047619 3.04761905c0 1.52380952 1.9047619 3.04761905 1.9047619 3.04761905z",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#j)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#d)",
    height: 9.904762,
    mask: "url(#j)",
    rx: 0.571429,
    width: 14.476191,
    x: 0.761905,
    y: 0.761905
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 9.14285714s2.2857143-1.53502372 2.2857143-3.42857143-2.2857143-3.42857142-2.2857143-3.42857142-2.28571429 1.53502371-2.28571429 3.42857142 2.28571429 3.42857143 2.28571429 3.42857143z",
    fill: "url(#c)",
    mask: "url(#j)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#j)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(6.095238 2.285714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9047619 6.47619048s1.90476191-1.52380953 1.90476191-3.04761905c0-1.52380953-1.90476191-3.04761905-1.90476191-3.04761905s-1.9047619 1.52380952-1.9047619 3.04761905c0 1.52380952 1.9047619 3.04761905 1.9047619 3.04761905z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.809524v3.809524h-3.809524z",
    fill: "url(#e)",
    mask: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.9047619 3.12380952-.67175457.467448.23698588-.78332594-.65215303-.49442719.8182199-.01667407.26870182-.7730208.26870183.7730208.8182199.01667407-.65215303.49442719.23698588.78332594z",
    fill: "url(#f)",
    mask: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.809524h3.809524v3.047619h-3.809524z",
    fill: "url(#g)",
    mask: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 4.57142857s1.21174355 1.14285714 1.52380952 1.14285714c.37195978 0 .37775021-.55104977.76190477-.76190476.60502161-.33208462 1.52380952-.38095238 1.52380952-.38095238v2.28571429h-3.80952381z",
    fill: "url(#h)",
    mask: "url(#n)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m7.81047817 4.93333758c-.00671489.06682762-.0166819.18036354-.02663268.32235632-.01212633.17303721-.02081745.3436592-.02458126.50387585-.00834857.35538045.00720967.61838108.06003421.77685459.06635139.19905424.21642895.38583327.4242771.56500411.15882332.13691013.31623574.24134822.42473341.30256136.09162111.05169152.20779886.01932225.25949036-.07229879.05169151-.09162104.01932229-.20779883-.07229874-.25949035-.08848396-.04992159-.22654392-.14152001-.36319299-.25931525-.16051215-.13836592-.27143451-.27641434-.31160602-.3969288-.03399611-.10198834-.04788731-.33680937-.04059002-.64744003.00361082-.15370645.01201166-.31862888.02375429-.48619103.00965745-.13780685.01929874-.24763316.025656-.31090124.01051741-.10467003-.06580846-.19804786-.17047848-.20856521-.10467002-.01051736-.19804785.06580846-.20856518.17047847z",
    fill: "url(#i)",
    fillRule: "nonzero",
    mask: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.85714286 5.71428571.76190476 1.14285715h-.76190476z",
    fill: "#fff",
    fillRule: "nonzero",
    mask: "url(#j)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGu);
export default __webpack_public_path__ + "static/media/GU.143d087e15402b58f4c494717b8a0172.svg";
export { ForwardRef as ReactComponent };